import React, { useState } from "react";

import Accordion from "~/components/child/ui/Accordion";
import { PairsSymbol } from "~/components/child/Symbols";
import { Node } from "~/components/child/editHistory/Node";

import bottomNavigationSvg from "~/assets/icon/arrows/bottomNavigation.svg";
import topNavigationSVG from "~/assets/icon/arrows/topNavigation.svg";

export const Card = ({ pair, timeFrame, breakCount, lowerPoints, upperPoints }) => {
  const isBroken = lowerPoints?.length > 0 || upperPoints?.length > 0;
  return (
    <Accordion
      className={{ root: "p-0 m-0" }}
      label={{
        leftPart: (
          <PairsSymbol pair={pair?.key} image={[pair?.image[0], pair?.image[1]]} />
        ),
        rightPart: (
          <div className="flex items-center text-xs font-robotoMed gap-1 text-storm-50">
            <span className="py-1.5 rounded-2xl px-2.5 bg-storm-20">{breakCount}</span>
            <span className="py-1.5 rounded-2xl px-2.5 bg-storm-20">{timeFrame}</span>
          </div>
        ),
      }}
      openDefault={false}
    >
      {isBroken && (
        <div
          className={`${
            lowerPoints?.length !== 1 || upperPoints?.length !== 1 ? "node" : ""
          } flex-col gap-2 flex items-center relative w-full`}
        >
          {lowerPoints?.map((node, index) => (
            <Node
              key={index}
              title={
                <span className={` flex font-roboto text-storm-80 text-sm`}>{node}</span>
              }
              details={
                <span className="flex p-2 bg-sky-20 rounded-xl">
                  <img src={bottomNavigationSvg} alt="icon" className="" />
                </span>
              }
              uuid={index}
              isActive={false}
            />
          ))}
          {upperPoints?.map((node, index) => (
            <Node
              key={index}
              title={
                <span className={` flex font-roboto text-storm-80 text-sm`}>{node}</span>
              }
              details={
                <span className="flex p-2 bg-sky-20 rounded-xl">
                  <img src={topNavigationSVG} alt="icon" className="" />
                </span>
              }
              uuid={index}
              isActive={false}
            />
          ))}
        </div>
      )}
    </Accordion>
  );
};

export const SecondStep = ({ vmcData, setVmcData, onSelectCard, isLoading }) => {
  const [selectedCarts, setSelectedCarts] = useState([]);

  const handleCartClick = (item, isSelected) => {
    if (!isSelected) {
      setSelectedCarts((prevState) => [
        ...prevState,
        { pair: item.pair.key, interval: item.timeframe },
      ]);
      onSelectCard(item.pair, item.timeframe);
    } else {
      setSelectedCarts((prevState) =>
        prevState?.filter(
          (cart) => !(cart.pair === item.pair.key && cart.interval === item.timeframe)
        )
      );
      setVmcData((prevState) => ({
        ...prevState,
        charts: prevState?.charts?.filter((chart) => {
          return !(
            chart.pair.key === item.pair.key && chart.timeframe === item.timeframe
          );
        }),
      }));
    }
  };
  return (
    <>
      <p className="text-xs text-oil-50">Display the chart:</p>
      <div className="flex flex-col gap-4 max-h-[76vh] pr-1 overflow-y-auto scrollbar-style-thumb scrollbar-style">
        {vmcData?.carts?.map((item, index) => {
          const isSelected = selectedCarts.some(
            (cart) => cart.pair === item.pair.key && cart.interval === item.timeframe
          );

          return (
            <button
              key={index}
              className={`px-2 disabled:cursor-not-allowed text-xs border rounded-lg ${
                isSelected ? "border-sky-40" : "border-storm-30"
              }`}
              onClick={() => handleCartClick(item, isSelected)}
              disabled={isLoading}
            >
              <Card
                pair={item.pair}
                timeFrame={item.timeframe}
                breakCount={item.breakCount}
                breakType={item.breakType}
                lowerPoints={item.lowerPoints}
                upperPoints={item.upperPoints}
              />
            </button>
          );
        })}
      </div>
    </>
  );
};
